import { Flex, Image, Text, Box } from '@chakra-ui/core'
import React from 'react'
import { Maybe, TaskEntity } from '../../../../generated/graphql'
import { Card, StatusBadge } from '../../../../components'
import { images } from '../../../../theme'
import { CardProps } from '../../../../components/Card'
import moment from 'moment'
import { getImageByFileExtension, getImages } from '../../../../utils'

type ListItemProps = {
  task: Maybe<TaskEntity>
} & CardProps
const ListItem: React.FC<ListItemProps> = ({ task, ...rest }) => {
  const image =
    task?.attributes?.project?.data?.attributes?.featured_image?.data?.attributes?.formats
      ?.thumbnail?.url ||
    task?.attributes?.task_definition?.data?.attributes?.project?.data?.attributes?.featured_image
      ?.data?.attributes?.formats?.thumbnail?.url ||
    images.baotreeLogo
  const projectName =
    task?.attributes?.project?.data?.attributes?.name ||
    task?.attributes?.task_definition?.data?.attributes?.project?.data?.attributes?.name ||
    'Unknown Project'

  const { images: taskImages, hasImages } = getImages(task)
  return (
    <Card rounded="lg" p={6} mb={3} mr={2} cursor="pointer" minW={48} {...rest}>
      <Flex>
        <Image
          src={image}
          alt={
            task?.attributes?.task_definition?.data?.attributes?.project?.data?.attributes?.name ||
            'Project Image'
          }
          objectFit="cover"
          rounded="lg"
          w={38}
          h={38}
          mr={3}
          bg="gray.100"
          p={1}
        />
        <Box>
          <Flex align="center" mb={2}>
            <Text fontSize="sm" fontWeight="500">
              {task?.attributes?.task_definition?.data?.attributes?.task_type?.data?.attributes
                ?.title || 'Unknown Task'}
            </Text>
            <StatusBadge status={task?.attributes?.status} mx={3} />
          </Flex>
          <Text fontSize="xs" color="gray.600">
            {projectName}
          </Text>
          {hasImages && (
            <Flex align="center" my={2}>
              {taskImages?.map((photo) => (
                <Image
                  key={photo.id}
                  src={
                    photo?.attributes?.mime.includes('image')
                      ? photo?.attributes?.formats?.thumbnail?.url ||
                        photo?.attributes?.url ||
                        images.baotreeLogo
                      : getImageByFileExtension(photo?.attributes?.name || '')
                  }
                  alt="Evidence"
                  w={10}
                  h={10}
                  objectFit="cover"
                  rounded="lg"
                  mr={2}
                />
              ))}
            </Flex>
          )}
        </Box>
        <Flex flex={1} justify="flex-end" align="center">
          <Text fontSize="xs" color="gray.500">
            {moment(task?.attributes?.createdAt).format('MMM DD, YYYY')}
          </Text>
        </Flex>
      </Flex>
    </Card>
  )
}

export default ListItem
